import { Component, OnInit, Output, EventEmitter, ViewChildren, QueryList, ElementRef, SimpleChanges, AfterViewChecked, ChangeDetectorRef, HostListener, AfterContentChecked } from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { Location } from '@angular/common';
import { DirectionsService } from 'src/app/services/directions.service';
import { MatDialog } from '@angular/material/dialog';
import { FuelDialogComponent } from '../fuel-dialog/fuel-dialog.component';


/**
 * Representa una opció per calcular la ruta
 */
export interface Option {
  value: string;
  viewValue: string;
}

/**
 * Representa un punt d'ubicació de la ruta
 */
export class Waypoint{
  value: string;
  autocomplete: boolean;
  id: string;
}

/**
 * Aquest component conté la interfícia necessària per que l'usuari calculi les rutes
 */
@Component({
  selector: 'app-rutes',
  templateUrl: './rutes.component.html',
  styleUrls: ['./rutes.component.css']
})
export class RutesComponent implements OnInit{

  @Output() directionsEmitter = new EventEmitter<string[]>();
  @Output() toggleEmitter = new EventEmitter<boolean>();
  @Output() preuKmEmitter = new EventEmitter<number>();
  @ViewChildren('waypoint') waypointChildren: QueryList<ElementRef<HTMLInputElement>>;
  @Output() selectedOption = new EventEmitter<string>();

  @HostListener('window:resize')
  onResize() {
    this.setScreenMode();
  }

  constructor(public dialog: MatDialog) { }

  idAutoIncrement = 2;
  rutaCalculada: boolean = false;

  tipusVehicle: string = "compacte"; // Indica el tipus de vehicle pel qual es vol fer el càlcul de ruta
  consumVehicle: number = 6.21; // Indica el consum del vehicle que s'espera per fer el càlcul de ruta
  combustible: string = "diesel"; // Indica el combustible que fa servir el combustible pel qual s'espera fer el càlcul de ruta
  preuCombustible: number = 1.25; // Preu del combustible que fa servir el vehicle pel qual es fa el càlcul de ruta

  screenMode: string = ''; // Indica el mode de pantalla en que està l'aplicació (escriptori, mòbil vertical o mòbil horitzontal)

  
  //Bounds ESP (+ Canàries).
  espLatLngBounds = new  google.maps.LatLngBounds(
    new google.maps.LatLng(26.709041066163724, -20.306056689891875),
    new google.maps.LatLng(44.811251049443776, 5.182224560108125)  
  );

  emitCalculateEvent() {
    this.checkAutocomplete();
    var waypointValues: string[] = [];
    this.waypoints.forEach(waypoint => waypointValues.push(waypoint.value));
    this.preuKmEmitter.emit(this.consumVehicle / 100 * this.preuCombustible)
    this.directionsEmitter.emit(waypointValues);
    this.toggleEmitter.emit(true);
  }

  

  selectOption(selected: string){
    this.selectedOption.emit(selected);
  }

  options: Option[] = [
    {value: 'mesCurta', viewValue: 'Més curta'},
    {value: 'evitaPeatges', viewValue: 'Evitar peatges'},
    {value: 'mesRapidaTrafic', viewValue: 'Més ràpida considerant tràfic'}
  ];

  lletres = ['A','B','C','D','E','F','G','H'];
  
  waypoints: Waypoint[] = [
    {value: '', autocomplete: false, id: 'waypoint0'},
    {value: '', autocomplete: false, id: 'waypoint1'}
  ];

  drop(event: CdkDragDrop<Waypoint[]>) {
    moveItemInArray(this.waypoints, event.previousIndex, event.currentIndex);
  }

  checkAutocomplete() {
    this.waypoints.forEach(element => {
      if(!element.autocomplete){
        let autocomplete = new google.maps.places.Autocomplete(<HTMLInputElement>document.getElementById(element.id), {bounds: this.espLatLngBounds});
        autocomplete.set('waypoint',element);
        autocomplete.addListener('place_changed', (event)=>{
          if(!autocomplete.getPlace().place_id) autocomplete.get("waypoint").value = autocomplete.getPlace().name;
          else {
            autocomplete.get("waypoint").value = autocomplete.getPlace().formatted_address;
          }          
  
        });

        element.autocomplete = true;
      }   
    });
  }

  setScreenMode(): void{
    if(window.innerWidth < 568)
      this.screenMode = 'portrait';
    else if(window.innerWidth < 824)
      this.screenMode = 'landscape';
    else 
      this.screenMode = 'desktop';
  }


  addWaypoint(){
    let newWaypoint: Waypoint = {value: '', autocomplete: false, id: 'waypoint' + this.idAutoIncrement};
    this.idAutoIncrement++;
    this.waypoints.push(newWaypoint);
  }

  deleteWaypoint(waypoint: Waypoint){
    this.waypoints = this.waypoints.filter(obj => obj.id !== waypoint.id);
  }

  swapWaypoints(){
    var a = this.waypoints[0];
    this.waypoints[0] = this.waypoints[1];
    this.waypoints[1] = a;
  }

  openFuelDialog(): void{
    const dialogRef = this.dialog.open(FuelDialogComponent,
      {
        autoFocus: false,
        width: '80%',
        height: '80%',
        maxWidth: '100vw',
        maxHeight: '100vh',
        data: {
          tipusVehicle: this.tipusVehicle,
          consumVehicle: this.consumVehicle,
          combustible: this.combustible,
          preuCombustible: this.preuCombustible,
        }
      }
    );

    dialogRef.afterClosed().subscribe(result => {
      if(result.saved){
        this.tipusVehicle = result.tipusVehicle;
        this.consumVehicle = result.consumVehicle;
        this.combustible = result.combustible;
        this.preuCombustible = result.preuCombustible;
      }
    })

  }

  

  ngOnInit() {
    this.setScreenMode();
  }



}
